import config from '@/config'
import axios from 'axios'
import { store } from '@/store/store'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const pageConfigApi = {
  postUpdatePageConfig: (body) => {
    return instance().post('/api/page-config', body)
  },
  postUnlockFeature: (request) => {
    const { data } = request
    // {
    //     "page_id": "146786585175702",
    //     "unlock_whatsapp": false,
    //     "unlock_webchat": false,
    //     "unlock_livechat": false
    // }
    return instance().post(`/api/page-config/cms/unlock-feature`, data)
  },
  postWarroomConfig: (request) => {
    const { data } = request
    // {
    //     "page_id": "",
    //     "warroom_clientid": "",
    //     "warroom_client_secret": "",
    //     "use_warroom_endpoint_production": true
    // }
    return instance().post(`/api/page-config/cms/warroom/config`, data)
  },
  getThemeList: (request) => {
    // limit=10&offset=0&theme=ticket&page_id=110703175198388
    const { params } = request
    return instance().get(`/api/page-config/cms/theme-list`, {
      params
    })
  },
  postThemeConfig: (request) => {
    const { data } = request
    // {
    //     "page_id": "110703175198388",
    //     "theme": "assetwise"
    // }
    return instance().post(`/api/page-config/cms/theme`, data)
  },
  postExpiredConfig: (request) => {
    const { data } = request
    // {
    //     "page_id": "110703175198388",
    //     "expireat": "YYYY-MM-DD"
    // }
    return instance().post(`/api/page-config/cms/page-exprire`, data)
  },
  postReplyCommentFlag: (request) => {
    const { data } = request
    // {
    //     "page_id": "110703175198388",
    //     "replycommentflag": true
    // }
    return instance().post(`/api/page-config/cms/reply-comment-flag`, data)
  },
  postShopPixelId: (body) => {
    return instance().post(`/api/page-config/cms/shop-pixel-id`, body)
  }
}

export default pageConfigApi



// WEBPACK FOOTER //
// ./src/api/page-config.js